export default __webpack_public_path__ + "static/media/aboutbanner.c52e9d91.svg";